"use strict";
exports.__esModule = true;
function identity(x) {
    return x;
}
exports.identity = identity;
// tslint:disable-next-line:no-any
function toPairs(obj) {
    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
}
exports.toPairs = toPairs;
function decodeHtmlEntity(str) {
    return str
        .replace(/&#\d{1,4};/g, function (match) {
        var code = Number(match.slice(2, -1));
        return String.fromCharCode(code);
    });
}
exports.decodeHtmlEntity = decodeHtmlEntity;
function assoc(key, value, obj) {
    return Object.assign({}, obj, (_a = {}, _a[key] = value, _a));
    var _a;
}
exports.assoc = assoc;
function mapValues(processor, obj) {
    return Object.keys(obj)
        .reduce(function (acc, key) {
        return assoc(key, processor(obj[key]), acc);
    }, {});
}
exports.mapValues = mapValues;
function deepEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}
exports.deepEqual = deepEqual;
//# sourceMappingURL=helpers.js.map